import React from 'react';
import MarkdownToJsx, { MarkdownToJSX } from 'markdown-to-jsx';
import { Box, Link, Typography } from '@mui/material';

const codeStyles = {
  fontFamily: 'monospace',
  fontSize: '0.875em',
  backgroundColor: 'action.hover',
  padding: '0.1em 0.35em',
  borderRadius: '4px',
};

const InlineCode = ({
  children,
  ...props
}: React.HTMLAttributes<HTMLElement>) => (
  <Box component="code" sx={codeStyles} {...props}>
    {children}
  </Box>
);

const markdownOptions: MarkdownToJSX.Options = {
  overrides: {
    h1: {
      component: Typography,
      props: { variant: 'h4', component: 'h1', gutterBottom: true },
    },
    h2: {
      component: Typography,
      props: { variant: 'h5', component: 'h2', gutterBottom: true },
    },
    h3: {
      component: Typography,
      props: { variant: 'h6', component: 'h3', gutterBottom: true },
    },
    p: {
      component: Typography,
      props: { variant: 'body1', paragraph: true },
    },
    a: {
      component: Link,
      props: { target: '_blank', rel: 'noopener noreferrer' },
    },
    li: {
      component: Typography,
      props: { component: 'li', variant: 'body1' },
    },
    code: {
      component: InlineCode,
    },
  },
};

const Markdown = ({ children }: { children: string }) => {
  return (
    <MarkdownToJsx options={markdownOptions}>{children}</MarkdownToJsx>
  );
};

export { Markdown };
